export default __webpack_public_path__ + "static/hot_tub_4-03a2f23dbf8b719afaf1fe21887547eb.jpg";